import { useQuery } from '@tanstack/react-query';
import sportsApi from '../../utils/sportsApi';
import { useRightsholderAttribution } from './useRightsholderAttribution';
import { Client } from '../../types/api';

const fetchPlacements = async ({
    clientId,
    rightsholderId,
    useRightsholderAttribution,
}: {
    clientId: number;
    rightsholderId: number;
    useRightsholderAttribution: boolean;
}) => {
    const includeTextFlag = 'includeTextTrackingPlacements=true';
    const endpoint = `/clients/${clientId}/rightsholders/${rightsholderId}/placements?${includeTextFlag}${
        useRightsholderAttribution ? '&useRightsholderAttribution=true' : ''
    }`;
    const placements = await sportsApi.url(endpoint).get().json();
    return { rightsholderId, placements };
};
const usePlacements = ({
    clientId,
    rhIds,
    client,
}: {
    clientId: number;
    rhIds: number[];
    client?: Client | null;
}) => {
    const { rightsholderAttribution } = useRightsholderAttribution({ client });

    return useQuery({
        queryKey: ['placements', clientId, rhIds, rightsholderAttribution],
        queryFn: async () => {
            const results = await Promise.all(
                rhIds.map(rhId =>
                    fetchPlacements({
                        clientId,
                        rightsholderId: rhId,
                        useRightsholderAttribution:
                            rightsholderAttribution === 'league',
                    }),
                ),
            );
            return results;
        },
        enabled: rhIds.length > 0,
    });
};

export default usePlacements;
